const coupon = payload => ({
  isValid: Boolean(payload.can_redeem) || false,
  couponSku: payload.campaign?.sku || '',
});

export { coupon };
